import React from "react";
import { Field, BaseProps } from "./field";
import { Input, InputAdornment, CircularProgress } from "@material-ui/core";

type Props = BaseProps<string> & {
  loading?: boolean;
  maxLength?: number;
  placeholder?: string;
  className?: any;
  type?: "text" | "number" | "email" | "tel";
};

export const Textbox: React.FC<Props> = (props) => {
  function onChange(event: React.ChangeEvent<HTMLInputElement>): void {
    if (props.onChange) {
      props.onChange(props.name, event.target.value);
    }
  }

  return (
    <Field
      label={props.label}
      required={props.required}
      error={props.error}
      disabled={props.disabled}
      size={props.size}
    >
      <Input
        disabled={props.loading || props.disabled}
        error={!!props.error}
        inputProps={{
          maxLength: props.maxLength,
        }}
        className={props.className}
        name={props.name}
        onChange={onChange}
        placeholder={props.loading ? "Loading..." : props.placeholder || ""}
        required={props.required}
        endAdornment={
          props.loading ? (
            <InputAdornment position="start">
              <CircularProgress size="1rem" />
            </InputAdornment>
          ) : null
        }
        value={props.loading ? "" : props.value || ""}
        type={props.type || "text"}
      />
    </Field>
  );
};
